import { useEffect, useState, useCallback } from 'react';
import { api } from '../utils/api';
import { useAuth } from '../context/AuthContext';

const MODAIS = [['maritimo', 'Marítimo'], ['aereo', 'Aéreo'], ['rodoviario', 'Rodoviário']];
const nomeModal = (m) => (MODAIS.find(x => x[0] === m) || [m, m])[1];
const tipoLabel = { agente: 'Agente de carga', transportadora: 'Transportadora', terminal: 'Terminal de cargas', seguradora: 'Seguradora' };
const vazio = () => ({ id: null, tipo: 'agente', nome: '', cnpj: '', site: '', modais: [], observacoes: '', ativo: true, contatos: [{ nome: '', cargo: '', email: '', telefone: '', principal: true }] });
const lab = { fontSize: 12, fontWeight: 500, color: '#6B7289', display: 'block', marginBottom: 4 };

export default function Parceiros() {
  const { token, user } = useAuth();
  const ehAdmin = user?.role === 'mentor' || user?.admin === true;
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [aba, setAba] = useState('todos'); // todos | agente | transportadora
  const [status, setStatus] = useState('ativos'); // ativos | inativos | todos
  const [busca, setBusca] = useState('');
  const [form, setForm] = useState(null); // null = fechado
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [aviso, setAviso] = useState(null);

  const carregar = useCallback(() => {
    setCarregando(true);
    api.get('/parceiros', token).then(setLista).catch(e => setAviso({ texto: e.message, erro: true })).finally(() => setCarregando(false));
  }, [token]);
  useEffect(() => { carregar(); }, [carregar]);

  const avisar = (texto, erroFlag) => { setAviso({ texto, erro: !!erroFlag }); setTimeout(() => setAviso(null), 6000); };

  const q = busca.toLowerCase().trim();
  const visiveis = lista.filter(p =>
    (aba === 'todos' || p.tipo === aba) &&
    (status === 'todos' || (status === 'ativos' ? p.ativo : !p.ativo)) &&
    (!q || [p.nome, p.cnpj, ...(p.contatos || []).flatMap(c => [c.nome, c.email, c.telefone])].join(' ').toLowerCase().includes(q)));

  const abrirNovo = (tipo) => { setErro(''); setForm({ ...vazio(), tipo: tipo || (['transportadora', 'terminal', 'seguradora'].includes(aba) ? aba : 'agente') }); };
  const abrirEditar = (p) => {
    setErro('');
    setForm({ ...p, cnpj: p.cnpj || '', site: p.site || '', observacoes: p.observacoes || '', modais: p.modais || [],
      contatos: (p.contatos && p.contatos.length) ? p.contatos.map(c => ({ nome: c.nome || '', cargo: c.cargo || '', email: c.email || '', telefone: c.telefone || '', principal: !!c.principal })) : vazio().contatos });
  };

  const set = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));
  const setContato = (i, campo, valor) => setForm(f => ({ ...f, contatos: f.contatos.map((c, j) => j === i ? { ...c, [campo]: valor } : c) }));
  const marcarPrincipal = (i) => setForm(f => ({ ...f, contatos: f.contatos.map((c, j) => ({ ...c, principal: j === i })) }));
  const addContato = () => setForm(f => ({ ...f, contatos: [...f.contatos, { nome: '', cargo: '', email: '', telefone: '', principal: false }] }));
  const removerContato = (i) => setForm(f => {
    const novos = f.contatos.filter((_, j) => j !== i);
    if (novos.length && !novos.some(c => c.principal)) novos[0].principal = true;
    return { ...f, contatos: novos };
  });
  const toggleModal = (m) => setForm(f => ({ ...f, modais: f.modais.includes(m) ? f.modais.filter(x => x !== m) : [...f.modais, m] }));

  const salvar = async (e) => {
    e.preventDefault();
    setSalvando(true); setErro('');
    try {
      const corpo = { tipo: form.tipo, nome: form.nome, cnpj: form.cnpj, site: form.site, modais: form.modais, observacoes: form.observacoes, ativo: form.ativo, contatos: form.contatos };
      if (form.id) await api.put(`/parceiros/${form.id}`, corpo, token);
      else await api.post('/parceiros', corpo, token);
      setForm(null); carregar(); avisar(form.id ? 'Cadastro atualizado.' : 'Cadastro criado.');
    } catch (err) { setErro(err.message); }
    finally { setSalvando(false); }
  };

  const alternarAtivo = async (p) => {
    try {
      await api.put(`/parceiros/${p.id}`, { tipo: p.tipo, nome: p.nome, cnpj: p.cnpj, site: p.site, modais: p.modais, observacoes: p.observacoes, ativo: !p.ativo, contatos: p.contatos }, token);
      carregar(); avisar(p.ativo ? `${p.nome} marcado como inativo.` : `${p.nome} reativado.`);
    } catch (err) { avisar(err.message, true); }
  };

  const excluir = async (p) => {
    if (!window.confirm(`Excluir "${p.nome}" e todos os seus contatos? Esta ação não pode ser desfeita.\n\nDica: se só não usa mais, prefira marcar como inativo.`)) return;
    try { await api.del(`/parceiros/${p.id}`, token); carregar(); avisar('Cadastro excluído.'); }
    catch (err) { avisar(err.message, true); }
  };

  const abaBtn = (id, texto) => (
    <button onClick={() => setAba(id)} style={{ fontSize: 12, fontWeight: 600, padding: '6px 14px', borderRadius: 8, border: 'none', cursor: 'pointer', background: aba === id ? '#1A2ECC' : '#fff', color: aba === id ? '#fff' : '#6B7289', boxShadow: aba === id ? 'none' : '0 0 0 1px #E4E6EF inset' }}>{texto}</button>
  );

  return (
    <div style={{ padding: '28px 32px' }}>
      {aviso && <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999, maxWidth: 380, boxShadow: '0 6px 24px rgba(0,0,0,.18)', background: aviso.erro ? '#FDEAEA' : '#E6F7F1', border: '1px solid ' + (aviso.erro ? '#E8A5A5' : '#8FD6B8'), borderRadius: 10, padding: '12px 16px', fontSize: 13, color: aviso.erro ? '#922020' : '#0A6B47' }}>{aviso.texto}</div>}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20, gap: 12, flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-.02em' }}>Agentes, transportadoras, terminais e seguradoras</div>
          <div style={{ fontSize: 13, color: '#6B7289', marginTop: 3 }}>Cadastro da equipe SVSLOG, com os contatos de cada empresa. Alunos não têm acesso.</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn-ghost" onClick={() => abrirNovo('seguradora')}>+ Seguradora</button>
          <button className="btn-ghost" onClick={() => abrirNovo('terminal')}>+ Terminal</button>
          <button className="btn-ghost" onClick={() => abrirNovo('transportadora')}>+ Transportadora</button>
          <button className="btn-primary" onClick={() => abrirNovo('agente')}>+ Agente de carga</button>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 14, flexWrap: 'wrap' }}>
        {abaBtn('todos', 'Todos')}{abaBtn('agente', 'Agentes de carga')}{abaBtn('transportadora', 'Transportadoras')}{abaBtn('terminal', 'Terminais')}{abaBtn('seguradora', 'Seguradoras')}
        <select className="input-field" value={status} onChange={e => setStatus(e.target.value)} style={{ width: 150, marginLeft: 8 }}>
          <option value="ativos">Só ativos</option><option value="inativos">Só inativos</option><option value="todos">Ativos e inativos</option>
        </select>
        <input className="input-field" placeholder="Buscar empresa, contato, e-mail ou CNPJ..." value={busca} onChange={e => setBusca(e.target.value)} style={{ maxWidth: 360, flex: 1 }} />
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#FAFBFE' }}>
              {['Empresa', 'Tipo', 'Modais', 'Contato principal', 'Status', ''].map(h => (
                <th key={h} style={{ fontSize: 10, fontWeight: 600, color: '#6B7289', textAlign: 'left', padding: '10px 16px', textTransform: 'uppercase', letterSpacing: '.06em', borderBottom: '0.5px solid #E4E6EF' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visiveis.map(p => {
              const c = (p.contatos || []).find(x => x.principal) || (p.contatos || [])[0];
              return (
                <tr key={p.id} style={{ borderTop: '0.5px solid #E4E6EF', opacity: p.ativo ? 1 : .55 }}>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{p.nome}</div>
                    <div style={{ fontSize: 11, color: '#6B7289' }}>{p.cnpj || ''}{p.cnpj && (p.contatos || []).length ? ' · ' : ''}{(p.contatos || []).length ? `${p.contatos.length} contato${p.contatos.length > 1 ? 's' : ''}` : 'sem contatos'}</div>
                  </td>
                  <td style={{ padding: '12px 16px' }}><span className="badge badge-blue">{tipoLabel[p.tipo]}</span></td>
                  <td style={{ padding: '12px 16px', fontSize: 12, color: '#6B7289' }}>{(p.modais || []).map(nomeModal).join(', ') || '—'}</td>
                  <td style={{ padding: '12px 16px', fontSize: 12 }}>
                    {c ? (<><div style={{ fontWeight: 500 }}>{c.nome}{c.cargo ? <span style={{ color: '#9095A8', fontWeight: 400 }}> · {c.cargo}</span> : null}</div>
                      <div style={{ color: '#6B7289' }}>{[c.email, c.telefone].filter(Boolean).join(' · ')}</div></>) : <span style={{ color: '#9095A8' }}>—</span>}
                  </td>
                  <td style={{ padding: '12px 16px' }}><span className={`badge ${p.ativo ? 'badge-green' : 'badge-red'}`}>{p.ativo ? 'Ativo' : 'Inativo'}</span></td>
                  <td style={{ padding: '12px 16px', whiteSpace: 'nowrap' }}>
                    <button className="btn-ghost" style={{ fontSize: 11, padding: '5px 10px', marginRight: 6 }} onClick={() => abrirEditar(p)}>Editar</button>
                    <button className="btn-ghost" style={{ fontSize: 11, padding: '5px 10px', marginRight: ehAdmin ? 6 : 0 }} onClick={() => alternarAtivo(p)}>{p.ativo ? 'Inativar' : 'Reativar'}</button>
                    {ehAdmin && <button className="btn-ghost" style={{ fontSize: 11, padding: '5px 10px', color: '#D63B3B' }} onClick={() => excluir(p)}>Excluir</button>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {carregando && <div style={{ padding: 28, textAlign: 'center', color: '#6B7289', fontSize: 13 }}>Carregando...</div>}
        {!carregando && visiveis.length === 0 && <div style={{ padding: 32, textAlign: 'center', color: '#6B7289', fontSize: 13 }}>{lista.length ? 'Nenhum cadastro com esse filtro.' : 'Nenhum cadastro ainda. Clique em "+ Agente de carga" para começar.'}</div>}
      </div>

      {form && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 16 }}>
          <div className="card" style={{ width: 640, maxWidth: '100%', maxHeight: '92vh', overflowY: 'auto', borderRadius: 20 }}>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 18 }}>{form.id ? 'Editar cadastro' : 'Novo cadastro'}</div>
            <form onSubmit={salvar}>
              <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', gap: 12, marginBottom: 12 }}>
                <div>
                  <label style={lab}>Tipo</label>
                  <select className="input-field" value={form.tipo} onChange={e => set('tipo', e.target.value)} style={{ width: '100%', padding: '10px 12px', border: '1px solid #E4E6EF', borderRadius: 8, fontSize: 13, background: '#fff' }}>
                    <option value="agente">Agente de carga</option><option value="transportadora">Transportadora</option><option value="terminal">Terminal de cargas</option><option value="seguradora">Seguradora</option>
                  </select>
                </div>
                <div>
                  <label style={lab}>Nome da empresa</label>
                  <input className="input-field" value={form.nome} onChange={e => set('nome', e.target.value)} required autoFocus />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                <div><label style={lab}>CNPJ</label><input className="input-field" value={form.cnpj} onChange={e => set('cnpj', e.target.value)} placeholder="00.000.000/0000-00" /></div>
                <div><label style={lab}>Site</label><input className="input-field" value={form.site} onChange={e => set('site', e.target.value)} placeholder="www.empresa.com.br" /></div>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={lab}>Modais atendidos</label>
                <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
                  {MODAIS.map(([v, t]) => (
                    <label key={v} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer' }}>
                      <input type="checkbox" checked={form.modais.includes(v)} onChange={() => toggleModal(v)} /> {t}
                    </label>
                  ))}
                </div>
              </div>

              <div style={{ marginBottom: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                  <label style={{ ...lab, marginBottom: 0 }}>Contatos</label>
                  <button type="button" className="btn-ghost" style={{ fontSize: 11, padding: '4px 10px' }} onClick={addContato}>+ Contato</button>
                </div>
                {form.contatos.map((c, i) => (
                  <div key={i} style={{ background: '#F7F8FC', borderRadius: 10, padding: 10, marginBottom: 8 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                      <input className="input-field" placeholder="Nome" value={c.nome} onChange={e => setContato(i, 'nome', e.target.value)} />
                      <input className="input-field" placeholder="Cargo / área (ex.: comercial)" value={c.cargo} onChange={e => setContato(i, 'cargo', e.target.value)} />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 6 }}>
                      <input className="input-field" type="email" placeholder="E-mail" value={c.email} onChange={e => setContato(i, 'email', e.target.value)} />
                      <input className="input-field" placeholder="Telefone / WhatsApp" value={c.telefone} onChange={e => setContato(i, 'telefone', e.target.value)} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, cursor: 'pointer', color: '#6B7289' }}>
                        <input type="radio" name="principal" checked={!!c.principal} onChange={() => marcarPrincipal(i)} /> Contato principal
                      </label>
                      {form.contatos.length > 1 && <button type="button" onClick={() => removerContato(i)} style={{ background: 'none', border: 'none', color: '#D63B3B', fontSize: 12, cursor: 'pointer' }}>Remover</button>}
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ marginBottom: 12 }}>
                <label style={lab}>Observações</label>
                <textarea className="input-field" rows={3} value={form.observacoes} onChange={e => set('observacoes', e.target.value)} style={{ resize: 'vertical' }} placeholder="Condições, rotas fortes, prazos de pagamento..." />
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer', marginBottom: 12 }}>
                <input type="checkbox" checked={form.ativo} onChange={e => set('ativo', e.target.checked)} /> Cadastro ativo (desmarcar tira da lista de escolha nas cotações)
              </label>

              {erro && <div style={{ background: '#FDEAEA', border: '0.5px solid #E8A5A5', borderRadius: 8, padding: '10px 14px', fontSize: 12, color: '#922020', marginBottom: 12 }}>{erro}</div>}
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button type="button" className="btn-ghost" onClick={() => setForm(null)}>Cancelar</button>
                <button type="submit" className="btn-primary" disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar →'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
